import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/_/strategy")({
	component: StrategyLayout,
});

function StrategyLayout() {
	return <Outlet />;
}
